import {
  Box,
  HStack,
  Icon,
  SkeletonCircle,
  SkeletonText,
  Text,
  VStack,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import {
  RiBookmarkLine,
  RiCalendarTodoFill,
  RiTimerLine,
  RiTvLine,
} from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../../helpers/api";
import Player from "../../vdoPlayer/player";

const VideoPreview = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const [otp, setOtp] = useState("");
  const [playBack, setPlayBack] = useState("");
  const videoDetails = useSelector((state) => state.chapterVideos.videoDetails);
  const seenLoading = useSelector((state) => state.chapterVideos.seenLoading);

  const getVideoData = async (id) => {
    //console.log(id, "get");
    const res = await axiosInstance.get(`/student/videos/otp/${id}`);
    setOtp(res?.data?.otp);
    setPlayBack(res?.data?.playbackInfo);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  useEffect(() => {
    if (id) {
      getVideoData(id);
    }
  }, [id]);
  return (
    <VStack
      bg="main_1"
      borderRadius="8px"
      p="20px"
      color="white"
      w="100%"
      h="100%"
      alignItems="flex-start"
      spacing="15px"
      position="relative"
    >
      {/* title */}
      <Text fontSize="28px" fontWeight="500">
        {videoDetails?.title}
      </Text>

      {/* videoDetails */}
      <Box bg="gray" w="100%" h="100%" alignSelf="center" borderRadius="8px">
        {videoDetails?.views_count?.views_count >
          videoDetails?.max_allowed_views ||
        (videoDetails?.suspended === 1 &&
          videoDetails?.user_video_suspended !== 0) ? (
          videoDetails?.views_count?.views_count > 2 ? (
            <Text textAlign="center" p={4} fontSize="20px">
              You have exceeded your views
            </Text>
          ) : (
            <Text textAlign="center" p={4} fontSize="20px">
              You must submit the previous homework to view this videoDetails
            </Text>
          )
        ) : videoDetails?.video_type == 2 ? (
          <div dangerouslySetInnerHTML={{ __html: videoDetails?.url }}></div>
        ) : loading ? null : (
          <Player otp={otp} playbackInfo={playBack} data={videoDetails} />
        )}
      </Box>

      {/* options */}
      {seenLoading ? (
        <HStack w="100%" bg="transparent">
          <SkeletonCircle size="6" startColor="gray.100" endColor="gray.600" />
          <SkeletonText
            startColor="gray.100"
            endColor="gray.600"
            w="80%"
            mt="4"
            noOfLines={1}
            spacing="4"
          />
        </HStack>
      ) : (
        <HStack
          justifyContent="space-between"
          w="100%"
          fontSize={{ base: "10px", lg: "18px" }}
        >
          <HStack spacing={{ base: "5px", lg: "50px" }}>
            <HStack spacing="8px" w="100%">
              <Icon as={RiCalendarTodoFill} />
              <Text w="fit-content">
                {dayjs(videoDetails?.created_at).format("D , MMM ,YYYY")}
              </Text>
            </HStack>
            {/* {diff && (
              <HStack spacing="8px" w="100%">
                <Icon as={RiTimerLine} />
                <Text w="fit-content">{diff} Days remaining</Text>
              </HStack>
            )} */}
            {videoDetails?.views_count && (
              <HStack spacing="8px" w="100%">
                <Icon as={RiTvLine} />
                <Text w="fit-content">{`Watch ${
                  videoDetails?.max_allowed_views -
                    (videoDetails?.views_count?.views_count >
                    videoDetails?.max_allowed_views
                      ? videoDetails?.max_allowed_views
                      : videoDetails?.views_count?.views_count) || 0
                } more times (${
                  videoDetails?.views_count?.views_count
                    ? videoDetails?.views_count?.views_count >
                      videoDetails?.max_allowed_views
                      ? videoDetails?.max_allowed_views
                      : videoDetails?.views_count?.views_count
                    : 0
                }/${
                  videoDetails?.max_allowed_views
                    ? videoDetails?.max_allowed_views
                    : 0
                })`}</Text>
              </HStack>
            )}
          </HStack>

          <Icon as={RiBookmarkLine} display={{ base: "none", lg: "block" }} />
        </HStack>
      )}
    </VStack>
  );
};

export default VideoPreview;
